import * as actionTypes from '../action-types';
import { UserWatchersActions } from '../actions';

type Reducer = { [uniqueId: string]: string };

const defaultState: Reducer = {};

export function userWatchersMapReducer(
  state = defaultState,
  action: UserWatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_USER_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.reduce((acc: Reducer, item) => {
        acc[item.uniqueId] = item.key;
        return acc;
      }, {});
    }
    case actionTypes.SET_USER_WATCHER: {
      const { watcher } = action.payload;
      return { ...state, [watcher.uniqueId]: watcher.key };
    }
    case actionTypes.UNSET_USER_WATCHER: {
      const { uniqueId } = action.payload;
      const { [uniqueId]: toDelete, ...rest } = state;
      return rest;
    }
    default: {
      return state;
    }
  }
}
